import { headlines } from "@/mocks/guaContent";

function Meta({ a }: { a: { reads: string; comments: string; time: string; author: string } }) {
  return (
    <div className="mt-3 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-foreground-500">
      <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{a.reads}</span>
      <span className="flex items-center gap-1"><i className="ri-chat-3-line"></i>{a.comments}</span>
      <span className="flex items-center gap-1"><i className="ri-time-line"></i>{a.time}</span>
      <span className="hidden sm:flex items-center gap-1"><i className="ri-user-line"></i>{a.author}</span>
    </div>
  );
}

export default function Headlines() {
  const [featured, ...rest] = headlines;

  return (
    <section id="briefing" className="relative bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <p className="text-sm font-semibold text-primary-600 tracking-wide">BRIEFING · 瓜报头条</p>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-900">
              编辑精选 · 值得细看的热点
            </h2>
          </div>
          <a
            href="#plans"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-primary-600 hover:text-primary-700 transition"
          >
            想看完整版？订阅瓜报 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        {/* 头条大图 */}
        <article className="group mt-10 grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:shadow-none">
          <div className="relative aspect-[16/10] lg:aspect-auto overflow-hidden">
            <img
              src={featured.image}
              alt={featured.title}
              className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
            />
          </div>
          <div className="p-6 md:p-9 flex flex-col justify-center">
            <div className="flex items-center gap-2">
              <span className="rounded-full bg-primary-500 text-white text-xs px-2.5 py-1 whitespace-nowrap">
                {featured.tag}
              </span>
              <span className="text-xs text-foreground-500">{featured.channel}</span>
            </div>
            <h3 className="mt-4 font-heading text-xl md:text-2xl font-bold text-foreground-900 leading-snug group-hover:text-primary-700 transition">
              {featured.title}
            </h3>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{featured.excerpt}</p>
            <Meta a={featured} />
            <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
              阅读全文 <i className="ri-arrow-right-line transition group-hover:translate-x-1"></i>
            </span>
          </div>
        </article>

        {/* 其余卡片流 */}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {rest.map((a) => (
            <article
              key={a.title}
              className="group flex flex-col rounded-lg bg-background-50 border border-background-200 overflow-hidden hover:-translate-y-1 transition duration-300"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <img
                  src={a.image}
                  alt={a.title}
                  className="w-full h-full object-cover transition duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-background-50/90 text-foreground-800 text-xs px-2.5 py-1 whitespace-nowrap">
                  {a.channel}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold text-foreground-900 leading-snug group-hover:text-primary-700 transition">
                  {a.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{a.excerpt}</p>
                <div className="mt-auto pt-3">
                  <Meta a={a} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}